import {createSettingInputs} from '../commonSettingInputs';
import * as css from './ClubForm.css.js';
import DataItem from '../../../component/dataItem/DataItem';
import Input from '../../../component/input/Input';
import {SUCCESS_COLOR} from '../../../globalVariables/GlobalVariables';
import {addCoupon, removeCoupon} from '../../../redux/event/eventActions';
import SubSettingItem from '../subSettingItem/SubSettingItem';

export const createClubSettingInputs = (clubs, category, settingsXHR, t, clearSelectedTicket) => {
    const settingInputs = createSettingInputs(clubs, category, settingsXHR, t, css);

    const updateCoupon = async (name, value, clubId, selectedTicket) => {
        const club = clubs.find(club => club.clubId === clubId);
        const couponData = {
            code: null,
            title: `${selectedTicket.text} ${club.clubName} ${t('clubBenefit')}`,
            clubId: clubId,
            cid: selectedTicket.cid
        };
        const couponTicketClubData = {
            tid: selectedTicket.key,
            ticketToken: value
        };
        const result = await addCoupon(couponData, couponTicketClubData, club.title);
        if(result && clearSelectedTicket && !selectedTicket.cid) {
            clearSelectedTicket(clubId);
        }
    };
    const onClear = (cid, clubId) => {
        cid &&removeCoupon(cid);
        clearSelectedTicket(clubId);
    };
    return {
        ...settingInputs,
        getTicketsList: (name, tickets, label, clubId, onTicketSelect) => {
            const dataItemsList = tickets.map(ticket => ({
                ...ticket,
                selected: false
            }));

            return settingInputs.getDataItems(
                name,
                dataItemsList,
                label,
                (name, key) => {
                    const selectedTicket = tickets.find(ticket => ticket.key === key);
                    onTicketSelect(clubId, selectedTicket);
                }, 2,t('selectTicket'), 'plus', '180px'
            );
        },
        getTicketTokenInput: (name, selectedTicket, label, clubId) => {
            if(!selectedTicket) return null;
            return (
                <SubSettingItem text={label}>
                    <css.input>
                        <css.tokenRow>
                            <Input
                                name={name}
                                events={{onBlur: (name, value) => updateCoupon(name, value, clubId, selectedTicket)}}
                                className={settingsXHR?.[`${name}XHR`]}
                            />
                            <DataItem
                                onClear={() => onClear(selectedTicket.cid, clubId)}
                                value={selectedTicket.text}
                                icon="success"
                                color={SUCCESS_COLOR}
                            />
                        </css.tokenRow>
                    </css.input>
                </SubSettingItem>
            );
        }
    };
};
